import { render, staticRenderFns } from "./SoccerChalkboardXg.vue?vue&type=template&id=6e5534f9&scoped=true&"
import script from "./SoccerChalkboardXg.vue?vue&type=script&lang=js&"
export * from "./SoccerChalkboardXg.vue?vue&type=script&lang=js&"
import style0 from "./SoccerChalkboardXg.vue?vue&type=style&index=0&id=6e5534f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5534f9",
  null
  
)

export default component.exports